/**
 * @generated SignedSource<<361cc83b68d9a3db3a0b95252b83f59f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type meQuery$variables = {};
export type meQuery$data = {
  readonly me: {
    readonly user: {
      readonly account_id: string;
      readonly email?: string;
      readonly locale?: string | null;
      readonly name: string;
      readonly picture: string;
      readonly zoneinfo?: string | null;
    };
  };
};
export type meQuery = {
  response: meQuery$data;
  variables: meQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "account_id",
  "kind": "ScalarField",
  "name": "accountId"
},
v1 = {
  "kind": "ScalarField",
  "name": "picture"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "email"
},
v4 = {
  "kind": "ScalarField",
  "name": "zoneinfo"
},
v5 = {
  "kind": "ScalarField",
  "name": "locale"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "meQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v0/*: any*/),
                  "action": "THROW",
                  "path": "me.user.account_id"
                },
                {
                  "kind": "RequiredField",
                  "field": (v1/*: any*/),
                  "action": "THROW",
                  "path": "me.user.picture"
                },
                {
                  "kind": "RequiredField",
                  "field": (v2/*: any*/),
                  "action": "THROW",
                  "path": "me.user.name"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": (v3/*: any*/),
                      "action": "THROW",
                      "path": "me.user.email"
                    },
                    (v4/*: any*/),
                    (v5/*: any*/)
                  ],
                  "type": "AtlassianAccountUser"
                }
              ]
            },
            "action": "THROW",
            "path": "me.user"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "meQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7c8155656ed0f4fbe918d873a4ceb431",
    "id": null,
    "metadata": {},
    "name": "meQuery",
    "operationKind": "query",
    "text": "query meQuery {\n  me {\n    user {\n      __typename\n      account_id: accountId\n      picture\n      name\n      ... on AtlassianAccountUser {\n        email\n        zoneinfo\n        locale\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1568289b39700f54ac688cda9f0119b6";

export default node;
